<ng-container *ngIf="airKeywordSearchForm && keywordList">
    <h2 class="form-title">{{ wording.servicesIncluded }}</h2>
    <form [formGroup]="airSearchForm">
        <multiselect
                [options]="keywordList"
                [fieldConfig]="{
                  formControlName: 'keyword',
                  formGroup: airSearchForm
                }"></multiselect>
    </form>
</ng-container>

